import "chartjs-adapter-moment";
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
} from "chart.js";
import type { ChartType, TooltipPositionerFunction } from "chart.js";
import { CHART_CUSTOM_POSITION_KEY } from "common/constants";
import { markedPointTooltipPositioner } from "./tooltipPositioner";

declare module "chart.js" {
  interface TooltipPositionerMap {
    [CHART_CUSTOM_POSITION_KEY]: TooltipPositionerFunction<ChartType>;
  }
}

Chart.register(
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip
);

Tooltip.positioners[CHART_CUSTOM_POSITION_KEY] = markedPointTooltipPositioner;
